"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9905,4123,7733],{

/***/ 44305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowLeft2; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19599);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43493);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);




var _excluded = ["variant", "color", "size"];

var Bold = function Bold(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M13.978 5.319l-3.21 3.21-1.97 1.96a2.13 2.13 0 000 3.01l5.18 5.18c.68.68 1.84.19 1.84-.76V6.079c0-.96-1.16-1.44-1.84-.76z"
  }));
};

var Broken = function Broken(_ref2) {
  var color = _ref2.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.19 7.94l-2.62 2.62c-.77.77-.77 2.03 0 2.8l6.52 6.52M15.09 4.04l-1.04 1.04"
  }));
};

var Bulk = function Bulk(_ref3) {
  var color = _ref3.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M10.77 8.52l5.05 3.79v5.61c0 .96-1.16 1.44-1.84.76L8.8 13.51a2.13 2.13 0 010-3.01l1.97-1.98z",
    opacity: ".4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M15.82 6.08v6.23l-5.05-3.79 3.21-3.21c.68-.67 1.84-.19 1.84.77z"
  }));
};

var Linear = function Linear(_ref4) {
  var color = _ref4.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 19.92L8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08"
  }));
};

var Outline = function Outline(_ref5) {
  var color = _ref5.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M15 20.67c-.19 0-.38-.07-.53-.22l-6.52-6.52a2.74 2.74 0 010-3.86l6.52-6.52c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6.52 6.52c-.48.48-.48 1.26 0 1.74l6.52 6.52c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22z"
  }));
};

var TwoTone = function TwoTone(_ref6) {
  var color = _ref6.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 19.92L8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08"
  }));
};

var chooseVariant = function chooseVariant(variant, color) {
  switch (variant) {
    case 'Bold':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Bold, {
        color: color
      });

    case 'Broken':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Broken, {
        color: color
      });

    case 'Bulk':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Bulk, {
        color: color
      });

    case 'Linear':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Linear, {
        color: color
      });

    case 'Outline':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Outline, {
        color: color
      });

    case 'TwoTone':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TwoTone, {
        color: color
      });

    default:
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Linear, {
        color: color
      });
  }
};

var ArrowLeft2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref7, ref) {
  var variant = _ref7.variant,
      color = _ref7.color,
      size = _ref7.size,
      rest = (0,_rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__._)(_ref7, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__.a)({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }), chooseVariant(variant, color));
});
ArrowLeft2.propTypes = {
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['Linear', 'Bold', 'Broken', 'Bulk', 'Outline', 'TwoTone']),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)])
};
ArrowLeft2.defaultProps = {
  variant: 'Linear',
  color: 'currentColor',
  size: '24'
};
ArrowLeft2.displayName = 'ArrowLeft2';




/***/ }),

/***/ 94266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ _objectWithoutProperties; },
/* harmony export */   "a": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}




/***/ }),

/***/ 49905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92734);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92433);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41464);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92021);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96528);
/* harmony import */ var iconsax_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(44305);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var components_kit_Description__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14123);
/* harmony import */ var constants_endPoint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36933);
/* harmony import */ var hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83910);
/* harmony import */ var utility_baseURL__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95877);
/* harmony import */ var utility_shimmer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34115);














var ImageKit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79307)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "12.7rem",
            padding: "0.5rem",
            background: theme.palette.background.light,
            borderRadius: theme.shape.medium,
            boxShadow: " 0px 27px 50px -7px rgba(0, 0, 0, 0.06)",
            position: "relative",
            transition: theme.transitions.create([
                "all",
                "transform"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                transform: "scale(1.03)",
                boxShadow: theme.shadows[1]
            }
        },
        BoxImage: {
            borderRadius: theme.shape.medium,
            display: "flex",
            flexDirection: "column"
        },
        images: {
            width: "100%",
            height: "100%",
            borderRadius: theme.shape.medium
        },
        content: {
            padding: " 0 0.8rem",
            marginTop: "1.6rem"
        },
        hoverArrow: {
            width: "2.1rem",
            height: "0.4rem",
            borderRadius: theme.shape.medium,
            background: theme.palette.secondary[700],
            boxShadow: " 0px 3px 9px ".concat(theme.palette.secondary[700])
        }
    };
});
var CategoryBox = function(props) {
    var ref, ref1, ref2, ref3;
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var classes = useStyles();
    var baseURL = (0,utility_baseURL__WEBPACK_IMPORTED_MODULE_8__/* .getOldBaseURL */ .v3)();
    var Name = props.Name, SupplierCount = props.SupplierCount, size = props.size, isArrow = props.isArrow, hoverFlag = props.hoverFlag;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(false), 2), hover = ref4[0], setHover = ref4[1];
    var isOnlyLg = (0,hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().isOnlyLg;
    var generateImage = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.CategoryImages) === null || ref === void 0 ? void 0 : ref.find(function(fd) {
        return fd.SupplierCategoryImageTypeID === "8";
    })) === null || ref1 === void 0 ? void 0 : ref1.FileUrl;
    var imageOfMap = (ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.image) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
        return item.FileUrl;
    })) === null || ref3 === void 0 ? void 0 : ref3.FileUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        className: classes.root,
        onMouseOver: function() {
            return hoverFlag && setHover(true);
        },
        onMouseOut: function() {
            return hoverFlag && setHover(false);
        }
    }, size === "large" && {
        style: {
            width: "15.9rem",
            height: "21rem"
        }
    }), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: classes.BoxImage,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageKit, {
                    src: baseURL + "".concat(generateImage || imageOfMap),
                    className: classes.images,
                    width: 120,
                    height: size === "large" ? isOnlyLg ? 120 : 150 : 120,
                    objectFit: "cover",
                    placeholder: "blur",
                    priority: true,
                    blurDataURL: "data:image/svg+xml;base64,".concat((0,utility_shimmer__WEBPACK_IMPORTED_MODULE_13__/* .shimmer */ .f)(120, 120))
                })
            }),
            size !== "large" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: ((props === null || props === void 0 ? void 0 : props.Name) || Name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: classes.content,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_kit_Description__WEBPACK_IMPORTED_MODULE_3__.DescriptionKit, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                        fontStyleTitleProps: {
                            color: theme.palette.text.dark,
                            fontWeight: 700
                        },
                        variantTitle: "subtitle1",
                        fontStyleSubTitleProps: {
                            fontSize: theme.typography.subtitle1,
                            color: theme.palette.text.disabled,
                            fontWeight: 500,
                            marginTop: "0.8rem"
                        },
                        direction: "column",
                        title: Name
                    }, SupplierCount && {
                        subTitle: "+".concat(SupplierCount, " فروشگاه ")
                    }), {
                        alignItems: "flex-start"
                    }))
                })
            }),
            size === "large" && isArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: "1.2rem 0.8rem",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        color: theme.palette.text.dark,
                        noWrap: true,
                        variant: "body1",
                        fontWeight: 700,
                        lineHeight: "2.2rem",
                        children: props === null || props === void 0 ? void 0 : props.Name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(iconsax_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        size: "20",
                        color: theme.palette.text.secondary
                    })
                ]
            }),
            hover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                width: "100%",
                className: "element-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    component: "span",
                    className: classes.hoverArrow
                })
            })
        ]
    }));
};
CategoryBox.defaultProps = {
    href: constants_endPoint__WEBPACK_IMPORTED_MODULE_4__/* .paths["/stores"] */ .H["/stores"],
    size: "large"
};
/* harmony default export */ __webpack_exports__["default"] = (CategoryBox);


/***/ }),

/***/ 14123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DescriptionKit": function() { return /* reexport */ Description; }
});

// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(34427);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(43903);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(22040);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(93359);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(41464);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/styles/makeStyles/makeStyles.js + 8 modules
var makeStyles = __webpack_require__(92021);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/index.js
var react = __webpack_require__(19599);
// EXTERNAL MODULE: ./src/components/common/Image/index.jsx
var Image = __webpack_require__(79307);
// EXTERNAL MODULE: ./src/hooks/useIconDynamic.jsx
var useIconDynamic = __webpack_require__(49193);
;// CONCATENATED MODULE: ./src/components/kit/Description/Description.jsx








var useStyle = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        keepaLink: {
            color: theme.palette.warning.main,
            "&:hover": {
                color: theme.palette.warning["400"]
            }
        },
        borderRadiusCustom: {
            borderRadius: theme.shape.large,
            padding: "5rem",
            textAlign: "center"
        },
        describeRow: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center"
        }, theme.breakpoints.between("xs", "sm"), {
            minWidth: "13rem "
        }),
        describeColumn: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        },
        tagNew: (0,_define_property/* default */.Z)({
            backgroundColor: theme.palette.info[700],
            borderRadius: theme.shape.large,
            marginRight: "0.8rem",
            width: "2.7rem",
            height: "1.8rem",
            display: "flex",
            padding: "0.8rem 2rem",
            justifyContent: "center",
            alignItems: "center",
            aspectRatio: "16/9"
        }, theme.breakpoints.between("xs", "sm"), {
            fontSize: "1rem !important",
            padding: "0.4rem"
        })
    };
});
var DescriptionKit = function(props) {
    var classes = useStyle();
    var direction = props.direction, title = props.title, subTitle = props.subTitle, textAlign = props.textAlign, icon = props.icon, fontStyleSubTitleProps = props.fontStyleSubTitleProps, fontStyleTitleProps = props.fontStyleTitleProps, tagNew = props.tagNew, alignItems = props.alignItems, store = props.store, iconImage = props.iconImage, styleIcon = props.styleIcon, iconElement = props.iconElement, justifyContent = props.justifyContent, iconExternal = props.iconExternal, others = (0,_object_without_properties/* default */.Z)(props, [
        "direction",
        "title",
        "subTitle",
        "textAlign",
        "icon",
        "fontStyleSubTitleProps",
        "fontStyleTitleProps",
        "tagNew",
        "alignItems",
        "store",
        "iconImage",
        "styleIcon",
        "iconElement",
        "justifyContent",
        "iconExternal"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            direction === "row" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.describeRow,
                alignItems: alignItems,
                justifyContent: justifyContent,
                children: [
                    iconImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: styleIcon,
                        width: styleIcon.width,
                        height: styleIcon.height,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                            src: iconImage,
                            alt: "icon"
                        })
                    }),
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: icon,
                        style: styleIcon
                    }),
                    iconElement && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: iconElement
                    }),
                    iconExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mr: "1.6rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useIconDynamic/* default */.Z, {
                            iconName: iconExternal,
                            innerProps: {
                                size: "25",
                                color: "#9B9BC4",
                                variant: "Outline"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.describeColumn,
                        alignItems: alignItems,
                        children: tagNew ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "baseline",
                                    flexDirection: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: others.variantTitle,
                                            style: fontStyleTitleProps,
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: classes.tagNew,
                                            children: "جدید"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: others.variantSubTitle,
                                    style: fontStyleSubTitleProps,
                                    children: subTitle
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: others.variantTitle,
                                    style: fontStyleTitleProps,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: others.variantSubTitle,
                                    style: fontStyleSubTitleProps,
                                    children: subTitle
                                })
                            ]
                        })
                    })
                ]
            }),
            direction === "column" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.describeColumn,
                alignItems: alignItems,
                justifyContent: justifyContent,
                children: [
                    iconImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: styleIcon,
                        width: styleIcon.width,
                        height: styleIcon.height,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                            src: iconImage,
                            alt: "icon"
                        })
                    }),
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: icon,
                        style: styleIcon
                    }),
                    iconElement && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: iconElement
                    }),
                    iconExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mr: "1.6rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useIconDynamic/* default */.Z, {
                            iconName: iconExternal,
                            innerProps: {
                                size: "25",
                                color: "#9B9BC4",
                                variant: "Outline"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: others.variantTitle,
                        style: fontStyleTitleProps,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        textAlign: textAlign,
                        variant: others.variantSubTitle,
                        style: fontStyleSubTitleProps,
                        display: "flex",
                        children: [
                            store && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: " فروشگاه"
                            }),
                            subTitle
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Description = (DescriptionKit);

;// CONCATENATED MODULE: ./src/components/kit/Description/index.js



/***/ }),

/***/ 49193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12241);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19599);





var DynamicIcon = function(param) {
    var iconName = param.iconName, innerProps = param.innerProps;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), IconComponent = ref[0], setIconComponent = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var loadIcon = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var module, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(1703), __webpack_require__.e(7048), __webpack_require__.e(1701), __webpack_require__.e(3566), __webpack_require__.e(6433), __webpack_require__.e(6914), __webpack_require__.e(565), __webpack_require__.e(1295)]).then(__webpack_require__.bind(__webpack_require__, 61295))
                            ];
                        case 1:
                            module = _state.sent();
                            setIconComponent(function() {
                                return module[iconName];
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadIcon() {
                return _ref.apply(this, arguments);
            };
        }();
        loadIcon();
    }, [
        iconName
    ]);
    if (!IconComponent) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, innerProps))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DynamicIcon);


/***/ }),

/***/ 561:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);